import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem;
  width: 77rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  h2 {
    ${(props) => `
      color: ${props.theme.colors.gray};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
  }

  .rows-wrapper {
    width: 100%;
    margin-top: 2.5rem;
    margin-bottom: 3.5rem;
  }

  .option-container {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;

    input {
      margin-right: 1.5rem;
      margin-top: -0.1rem;
    }
  }

  .logos-container {
    display: flex;
    align-content: space-around;
  }

  .bankLogo {
    margin-left: 0.3rem;
    display: flex;
    justify-content: center;
  }
`;

export const Row = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  margin-left: 6rem;
  margin-right: 6rem;
  padding: 1.5rem;

  p {
    color: ${(props) => props.theme.colors.blackTextTitle};
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    color: ${props.theme.colors.white};
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }

  img {
    height: 5rem;
    width: 5rem;
  }
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;
